<template>
<div class="baner">
  <div class="baner-header">
    <div class="baner-header-top">
      <a href="/">
        <div class="logo">
          <div class="logo-img">
            <img src="@/assets/Audi_biale.png" alt="Audi" class="logo-mobile img-responsive">
          </div>
          <div class="logo-text">
            <p>
              Dealer Audi <br>
              <strong>
                Porsche Poznań Franowo
              </strong>
            </p>
          </div>
        </div>
      </a>
      <a class="desktop-asp" href="/">
        <div class="logo">
          <div class="logo-text">
            <p class="logo-text-afs">
              <span>
                Audi
              </span>
              Financial Services
            </p>
          </div>
          <div class="logo-img">
            <img src="@/assets/Audi_biale.png" alt="Audi" class="logo-mobile img-responsive">
          </div>
        </div>
      </a>
    </div>

  </div>
  <div class="baner-header baner-header-bottom">
    <div class="baner-header-copy">
      <h1>Audi w pakiecie korzyści</h1>
      <p>
        Już dziś w Twoim garażu
      </p>
    </div>
    <div class="mobile-right">
      <a class="mobile-asp" href="/">
        <div class="logo mobile-asp-right">
          <div class="logo-text">
            <p class="logo-text-afs">
              <span>
                Audi
              </span>
              Financial Services
            </p>
          </div>
          <div class="logo-img">
            <img src="@/assets/Audi_biale.png" alt="Audi" class="logo-mobile img-responsive">
          </div>
        </div>
      </a>
      <a href="/">
        <img src="@/assets/asp.png" alt="Audi Select Plus" class="img-responsive baner-asp">
      </a>
    </div>
  </div>
  <img src="@/assets/baner.jpg" alt="">
</div>
</template>

<script>
export default {
  name: 'baner'
}
</script>

<style lang="scss" scoped>
.baner {
    line-height: 0;
    text-align: center;
    position: relative;
    img {
        max-width: 100%;
        height: auto;
    }
    &-header {
      text-align: left;
        line-height: 1.25;
        position: absolute;
        top: 1rem;
        left: 0;
        right: 0;
        right: 0;
        width: 100%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 1rem;
      &-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
            // max-width: 35vw;
        }
      }
      &-bottom{
        bottom: 4vw;
        top: auto;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        @media(max-width: 768px){
          position: relative;
          order: 2;
          top: -1px;
          background-color: #000;
          padding-bottom: 2rem;
        }
        @media(max-width:500px){
          display: block;
        }
      }
      &-copy{
        margin-top:5vh;
        color: #fff;
        h1{
          font-size: 3vw;
          margin: 0;
          @media(max-width:500px){
            font-size: 1.5rem;
          }
        }
        p{
          font-size: 1.8vw;
          margin: 0;
          font-weight: 600;
          @media(max-width:500px){
            font-size: 1rem;
          }
        }
        @media(max-width:500px){
          margin-bottom: 1rem;
        }
      }
      @media(max-width: 768px){
        position: relative;
        background-color: #000;
        top: 0;
      }

    }
    &-asp{
      @media(max-width: 768px){
        max-width: 200px!important;
      }
    }
    @media(max-width: 768px){
      display: flex;
      flex-direction: column;
    }
}
.logo{
  display: flex;
  align-items: center;
  &-img{
    max-width: 120px;
  }
  &-text{
    color: #fff;
    margin-left: 2rem;
    &-afs{
      font-weight: 700;
      margin-right: 2rem;
      & span{
        color: #c7102d;
      }
      @media(max-width:550px){
        margin-right: 10px;
        font-size: 12px;
      }
    }
    @media(max-width:550px){
      margin-left: 10px;
      font-size: 12px;
    }
  }
  &-mobile{
    @media(max-width: 610px){
      max-width: 80px!important;
    }
  }
}
.desktop-asp{

}
.mobile-asp{
  display: none;
}
@media(max-width: 500px){
  .desktop-asp{
    display: none;
  }
  .mobile-asp{
    display: block;
    margin-bottom: 1rem;
    &-right{
      justify-content: flex-end;
    }
  }
  .mobile-right{
    text-align: right;
  }
}
</style>
